/** Keep in sync with the --breakpoint-* tokens in src/index.css. */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

/**
 * Below this shortest side in CSS pixels a touch device is a handset, whatever
 * its orientation. An iPhone 13 in landscape is 844px wide but only 390px on its
 * shortest side, so it stays phone-shaped. An iPad Pro 11 measures 834px and
 * passes.
 */
export const HANDSET_MAX_SHORTEST_SIDE = 600;

/** Viewport width at which the machines list and its detail pane sit side by side. */
export const SPLIT_LAYOUT_MIN_WIDTH = BREAKPOINTS.lg;
